
import SvgIcon from "Theme/SvgIcon"
import { ReactComponent as SettingsIcon } from "../fontello/icons/svg/ic_settings.svg"


const Settings = ({ ...props }) => (
  <SvgIcon
    component={SettingsIcon}
    viewBox="0 0 1000 1000"
    {...props}
  />
)


export default Settings
